var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoUpcomingCourses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_178_11131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 24C39.5304 24 40.0391 24.2107 40.4142 24.5858C40.7893 24.9609 41 25.4696 41 26V28H73V26C73 25.4696 73.2107 24.9609 73.5858 24.5858C73.9609 24.2107 74.4696 24 75 24C75.5304 24 76.0391 24.2107 76.4142 24.5858C76.7893 24.9609 77 25.4696 77 26V28H81C83.1217 28 85.1566 28.8429 86.6569 30.3431C88.1571 31.8434 89 33.8783 89 36V80C89 82.1217 88.1571 84.1566 86.6569 85.6569C85.1566 87.1571 83.1217 88 81 88H33C30.8783 88 28.8434 87.1571 27.3431 85.6569C25.8429 84.1566 25 82.1217 25 80V44H89V40H25V36C25 33.8783 25.8429 31.8434 27.3431 30.3431C28.8434 28.8429 30.8783 28 33 28H37V26C37 25.4696 37.2107 24.9609 37.5858 24.5858C37.9609 24.2107 38.4696 24 39 24V24Z",
    fill: "#53A683",
    fillOpacity: 0.1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 7C24.5304 7 25.0391 7.21071 25.4142 7.58579C25.7893 7.96086 26 8.46957 26 9V11H58V9C58 8.46957 58.2107 7.96086 58.5858 7.58579C58.9609 7.21071 59.4696 7 60 7C60.5304 7 61.0391 7.21071 61.4142 7.58579C61.7893 7.96086 62 8.46957 62 9V11H66C68.1217 11 70.1566 11.8429 71.6569 13.3431C73.1571 14.8434 74 16.8783 74 19V63C74 65.1217 73.1571 67.1566 71.6569 68.6569C70.1566 70.1571 68.1217 71 66 71H18C15.8783 71 13.8434 70.1571 12.3431 68.6569C10.8429 67.1566 10 65.1217 10 63V19C10 16.8783 10.8429 14.8434 12.3431 13.3431C13.8434 11.8429 15.8783 11 18 11H22V9C22 8.46957 22.2107 7.96086 22.5858 7.58579C22.9609 7.21071 23.4696 7 24 7V7ZM14 23V63C14 64.0609 14.4214 65.0783 15.1716 65.8284C15.9217 66.5786 16.9391 67 18 67H66C67.0609 67 68.0783 66.5786 68.8284 65.8284C69.5786 65.0783 70 64.0609 70 63V23H14Z",
    fill: "#8DC5BB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_178_11131",
    x: 21,
    y: 20,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_178_11131"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_178_11131",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUpcomingCourses);
export default __webpack_public_path__ + "static/media/no-upcoming-courses.b68c2c3f.svg";
export { ForwardRef as ReactComponent };